import { useTranslation } from 'react-i18next'

import { GLOBAL_QUERY_OPTIONS } from '@ps/common-features/lib/api/constants/apiOptions'
import type { BaseQueryOptions } from '@ps/common-features/lib/api/types/query'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { getCurrentLanguage } from 'src/utils/locale/getCurrentLanguage'

import { serviceTrackingKeys } from '../serviceTracking.keys'
import { getServiceTracking } from '../serviceTracking.service'
import { TrackingData } from '../serviceTracking.types'

type UseGetRequestTrackingProps = {
  code?: string
  options?: BaseQueryOptions<TrackingData>
}

export const useGetRequestTracking = ({ code, options }: UseGetRequestTrackingProps) => {
  const { i18n } = useTranslation()
  const language = getCurrentLanguage(i18n)

  return useQuery({
    queryKey: serviceTrackingKeys.get(code!, language),
    queryFn: () => getServiceTracking(code!),
    enabled: !!code,
    placeholderData: keepPreviousData,

    ...GLOBAL_QUERY_OPTIONS,
    ...options,
  })
}
